const store = {
  state: {
    user: false
  },
  getters: {
    user: (state) => {
      return state.user
    }
  },
  mutations: {},
  actions: {
    user ({ commit }, data) {
      this.state.user = data
    }
  }
}
export default store



// WEBPACK FOOTER //
// ./src/store.js